import { ServiceNecessaryDataEnum } from "bonusx-api-main-manager";
import { IProductWithCmsDataAndQualification } from "../../pages/ProductsListPage/entities/product-with-cms-data-and-qualification/product-with-cms-data-and-qualification.entity.interface";
import getLastElementOfArray from "../../utils/getLastElementOfArray";
import { ProductNecessaryDataOption } from "../ApiClientBonusXServiceRepository/types/NecessaryDataPurchaseOptions.type";
import { IProductRequiredRequisites } from "./interfaces/ProductRequiredRequisites.interface";
import { IProductRequisitesService } from "./interfaces/ProductRequisitesService.interface";

export const requisitesOfInfoBonusDefaults: ProductNecessaryDataOption[] = [];

export const requisitesOfNotInfoBonusDefaults: ProductNecessaryDataOption[] = [ServiceNecessaryDataEnum.PersonalData];

export class ProductRequisitesService implements IProductRequisitesService {
  public getPurchasingInformation(product: IProductWithCmsDataAndQualification, sectionPercentages: number[]) {
    const requisites = product?.necessaryData ?? [];

    const requiredRequisites = this.getProductRequiredRequisites(requisites);
    const productRequisite = this.getProductRequisite(requiredRequisites, sectionPercentages);

    return { canPurchaseService: !productRequisite.requisite };
  }

  public getProductRequiredRequisites(requisites: ProductNecessaryDataOption[]): IProductRequiredRequisites[] {
    const requisiteIndexMap = {
      [ServiceNecessaryDataEnum.CitizenshipQuestionnaire]: 0,
      [ServiceNecessaryDataEnum.PersonalData]: 0,
      [ServiceNecessaryDataEnum.FamilyQuestionnaire]: 1,
      [ServiceNecessaryDataEnum.FamilyData]: 2,
      [ServiceNecessaryDataEnum.IncomeQuestionnaire]: 3,
      [ServiceNecessaryDataEnum.HeritageQuestionnaire]: 4,
      [ServiceNecessaryDataEnum.FullQuestionnaire]: 4,
    };

    const internalRequisites: IProductRequiredRequisites[] = requisites.map((requisite) => {
      return { index: requisiteIndexMap[requisite], requisite };
    });

    internalRequisites.sort((a, b) => a.index - b.index);
    return internalRequisites;
  }

  public getProductRequisite(requiredRequisites: IProductRequiredRequisites[], sectionPercentages: number[]) {
    const deniedRequisites = requiredRequisites.filter(
      (reqRequisite) => !this._areSectionsCompletedUntil(reqRequisite.index, sectionPercentages)
    );

    deniedRequisites.sort((a, b) => a.index - b.index);

    if (deniedRequisites.length > 0) {
      const deniedRequisite = getLastElementOfArray(deniedRequisites);

      return { requisite: deniedRequisite?.requisite, index: deniedRequisite?.index };
    } else {
      return { requisite: undefined, index: -1 };
    }
  }

  private _areSectionsCompletedUntil(index: number, sectionPercentages: number[]) {
    return sectionPercentages.every((percentage, i) => {
      return i > index || percentage === 100;
    });
  }
}
